
    <div class="report-model">


        <app-datatable-title [title]="'reports.unitRental'" [count]="retailUnitCount"  [countTitle]="'reports.totalUnits'"></app-datatable-title>

        <!-- <ng-container *ngIf="retailUnitLoading">
            <app-skeleton-loader [loaderSize]="8"></app-skeleton-loader>
        </ng-container> -->
        <app-report-datatable  class="default-table-view" [showLoader]="!retailUnitLoading" [tableColumns]="retailUnitColumns"
            [dataLength]="retailUnitCount" [tableData]="retailUnitdata"
            (pageEvent)="onPageEvent($event)"
            (sort)="sortData($event)" [allowExcelDownload]="true"
            (excelDownload)="downloadExcel($event, 'property_detail_retail_unit_rental')"
            [downloadLoading]="downloadLoading" [showEstaterText]="true"
            [reportSectionTitle]="'Unit Rental'">
        </app-report-datatable>


    </div>
